import type { Step } from '@/components/wizard/Step';

import {
  ConnectAzureSourceAccount,
  type AzureSourceAccountState,
} from '../connectAzureSourceAccount';

export const azureConnectSourceFlow: Step<AzureSourceAccountState> = {
  id: 'connect_azure_source',
  Component: ConnectAzureSourceAccount,
  nonReturnable: false,
};
